export default "__VITE_ASSET__cbV$gvyJ__"